// TODO: Preferably change tokens to ROW and COLUMN, just like CSS flex alignments.
// eslint-disable-next-line no-shadow
export enum FieldsetOrientation {
  INLINE = 'inline',
  STACKED = 'stacked',
}

// eslint-disable-next-line no-shadow
export enum InputType {
  LEGAL_CHECKBOX = 'form-legal-checkbox',
  DEFAULT_RADIO = 'default-radio',
  ENRICHED_RADIO = 'enriched-radio',
  DEFAULT_CHECKBOX = 'default-checkbox',
  ENRICHED_CHECKBOX = 'enriched-checkbox',
  TEXT_INPUT_CHECKBOX = 'text-input-checkbox',
  DEFAULT_TEXT = 'default-text',
  SELECT_DROPDOWN = 'select-dropdown',
}
